import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import './TopNav.css';

const TopNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();

  const navigationItems = [
    {
      path: '/',
      label: 'Home',
      title: 'Página Inicial'
    },
    {
      path: '/inventory',
      label: 'Estoque',
      title: 'Consulta de Estoque'
    },
    {
      path: '/orders',
      label: 'Pedidos',
      title: 'Kanban de Pedidos'
    },
    {
      path: '/smart-order-capture',
      label: 'Captura inteligente',
      title: 'Captura inteligente'
    },
    {
      path: '/reports',
      label: 'Relatórios',
      title: 'Relatórios do Sistema'
    },
    {
      path: '/mapeamentos',
      label: 'Notas de Entrada',
      title: 'Mapeamento de Notas de Entrada'
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleSignOut = () => {
    signOut();
    navigate('/');
  };

  const getUserInitials = () => {
    if (!user || !user.name) return '?';
    return user.name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <nav className="top-nav">
      <div className="nav-container">
        <div className="nav-brand">
          <span className="brand-icon">
            <img src="/logo_extensive.png" alt="Item4" />
          </span>
        </div>
        
        <div className="nav-links">
          {navigationItems.filter(item => item.if ? item.if(user) : true).map((item) => (
            <button
              key={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => handleNavigation(item.path)}
              title={item.title}
            >
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </div>
        
        <div className="nav-actions">
          {user && (
            <div className="user-info">
              <div className="user-avatar">
                {user.picture ? (
                  <img src={user.picture} alt={user.name} className="user-picture" />
                ) : (
                  <span className="user-initials">{getUserInitials()}</span>
                )}
              </div>
              <div className="user-details">
                <span className="user-name">{user.name}</span>
                <span className="user-email">{user.email}</span>
              </div>
              <button className="sign-out-btn" onClick={handleSignOut} title="Sair">
                <span>🚪</span>
              </button>
            </div>
          )}
          <div className="app-version">v1.0</div>
        </div>
      </div>
    </nav>
  );
};

export default TopNav;
